import { useState, MouseEvent, cloneElement } from 'react';

import { Dialog } from '../dialog';
import { Button } from '../button';

import { ConfirmDialogProps } from './types';

export const ConfirmDialog = ({
  trigger,
  message,
  onConfirm,
  confirmBtnColor,
  cancelText = 'Cancel',
  confirmText = 'Confirm',
  title = 'Are you sure?',
}: ConfirmDialogProps) => {
  const [open, setOpen] = useState(false);

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const handleConfirm = () => {
    onConfirm();
    handleClose();
  };

  const triggerElement = trigger
    ? cloneElement(trigger, {
        onClick: (e: MouseEvent) => {
          trigger.props?.onClick?.(e);
          handleOpen();
        },
      })
    : null;

  return (
    <>
      {triggerElement}

      <Dialog
        open={open}
        title={title}
        onClose={handleClose}
        actions={
          <>
            <Button variant="outlined" onClick={handleClose}>
              {cancelText}
            </Button>
            <Button color={confirmBtnColor} onClick={handleConfirm}>
              {confirmText}
            </Button>
          </>
        }
      >
        {message}
      </Dialog>
    </>
  );
};
